import { PageHeader } from '@/components/PageHeader';
import { ModelManagementDashboard } from '@/components/ModelManagementDashboard';

export default function ModelManagement() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="AI Model Management"
        description="Monitor, configure, and optimize your AI models for bill processing"
      />
      <ModelManagementDashboard />
    </div>
  );
}